import { render, staticRenderFns } from "./LatestLargeArticles.vue?vue&type=template&id=52bd992f&"
import script from "./LatestLargeArticles.vue?vue&type=script&lang=js&"
export * from "./LatestLargeArticles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports